import React from "react";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false
  };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Unhandled frontend error:", error, errorInfo);
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background: "linear-gradient(180deg, #f8fafc 0%, #eef6f2 100%)"
        }}>
          <div style={{
            maxWidth: "520px",
            width: "100%",
            background: "#ffffff",
            border: "1px solid #dbe7e2",
            borderRadius: "24px",
            padding: "28px",
            boxShadow: "0 20px 40px rgba(15, 23, 42, 0.08)"
          }}>
            <p style={{ margin: 0, color: "#0f766e", fontSize: "0.8rem", fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase" }}>
              Application Error
            </p>
            <h1 style={{ margin: "12px 0 10px", fontSize: "1.8rem", lineHeight: 1.1, color: "#0f172a" }}>
              Something went wrong in the portal.
            </h1>
            <p style={{ margin: 0, color: "#475569", lineHeight: 1.6 }}>
              The page crashed unexpectedly. Reload the portal to continue. If this keeps happening, check the browser console and backend logs.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                marginTop: "18px",
                padding: "12px 16px",
                borderRadius: "14px",
                border: "none",
                background: "#0f766e",
                color: "#ffffff",
                fontWeight: 700,
                cursor: "pointer"
              }}
            >
              Reload Portal
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
